import React, { useReducer } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./query-registration.css";
import { industriesCategoriesData } from "../../../industriesCategoriesData";

const steps = [
  { id: 1, label: "Industry" },
  { id: 2, label: "Business" },
  { id: 3, label: "Branding" },
  { id: 4, label: "Review" },
];

const initialForm = {
  business_Category: "",
  industryItem: "",
  businessName: "",
  business_address: "",
  businessDiscription: "",
  website: "",
  businessLogo: "",
};

function formReducer(state, action) {
  switch (action.type) {
    case "field":
      return {
        ...state,
        [action.field]: action.value,
      };

    case "reset":
      return initialForm;

    default:
      return state;
  }
}

export default function QueryRegistration() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, dispatch] = useReducer(formReducer, initialForm);

  const rawStep = parseInt(searchParams.get("step"), 10);
  const currentStep = Number.isNaN(rawStep)
    ? 1
    : Math.min(Math.max(rawStep, 1), steps.length);

  const changeStep = (step) => {
    const safeStep = Math.min(Math.max(step, 1), steps.length);
    setSearchParams({ step: String(safeStep) });
  };

  const handleNext = () => changeStep(currentStep + 1);
  const handlePrev = () => changeStep(currentStep - 1);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (currentStep < steps.length) {
      handleNext();
      return;
    }

    // Final form submission can be added here.
    navigate("/access/client-portal/authentication/sign-in");
  };

  const renderStepBody = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="queryStepFields">
            <label>
              Business Category
              <select
                name="business_Category"
                value={formData.business_Category}
                onChange={(event) => {
                  dispatch({
                    type: "field",
                    field: "business_Category",
                    value: event.target.value,
                  });

                  dispatch({
                    type: "field",
                    field: "industryItem",
                    value: "",
                  });
                }}
                required
              >
                <option value="">Select Business Category</option>

                {industriesCategoriesData.map((section) => (
                  <option key={section.section} value={section.section}>
                    {section.section}
                  </option>
                ))}
              </select>
            </label>

            <label>
              Industry
              <select
                name="industryItem"
                value={formData.industryItem}
                onChange={(event) =>
                  dispatch({
                    type: "field",
                    field: "industryItem",
                    value: event.target.value,
                  })
                }
                required
              >
                <option value="">Select Industry</option>

                {industriesCategoriesData
                  .find(
                    (section) => section.section === formData.business_Category,
                  )
                  ?.items.map((item) => (
                    <option key={item.title} value={item.title}>
                      {item.title}
                    </option>
                  ))}
              </select>
            </label>
          </div>
        );

      case 2:
        return (
          <div className="queryStepFields">
            <label>
              Business Name
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                onChange={(event) =>
                  dispatch({
                    type: "field",
                    field: "businessName",
                    value: event.target.value,
                  })
                }
                placeholder="Company or store name"
                required
              />
            </label>

            <label>
              Business Address (optional)
              <input
                type="text"
                name="business_address"
                value={formData.business_address}
                onChange={(event) =>
                  dispatch({
                    type: "field",
                    field: "business_address",
                    value: event.target.value,
                  })
                }
                placeholder="E.g. Plot 838, Garki Area 11, Abuja, Nigeria"
              />
            </label>
          </div>
        );

      case 3:
        return (
          <div className="queryStepFields">
            <label>
              Business Description
              <input
                type="text"
                name="businessDiscription"
                value={formData.businessDiscription}
                onChange={(event) =>
                  dispatch({
                    type: "field",
                    field: "businessDiscription",
                    value: event.target.value,
                  })
                }
                placeholder="E.g. Retail, FMCG, Logistics"
                required
              />
            </label>

            <label>
              Website
              <input
                type="text"
                name="website"
                value={formData.website}
                onChange={(event) =>
                  dispatch({
                    type: "field",
                    field: "website",
                    value: event.target.value,
                  })
                }
                placeholder="https://example.com"
              />
            </label>

            <label>
              Business Logo
              <input
                type="text"
                name="businessLogo"
                value={formData.businessLogo}
                onChange={(event) =>
                  dispatch({
                    type: "field",
                    field: "businessLogo",
                    value: event.target.value,
                  })
                }
                placeholder="Logo URL"
              />
            </label>
          </div>
        );

      case 4:
        return (
          <div className="queryReviewSection">
            <h3>Review your registration details</h3>

            <dl>
              <dt>Business Category</dt>
              <dd>{formData.business_Category || "—"}</dd>

              <dt>Industry</dt>
              <dd>{formData.industryItem || "—"}</dd>

              <dt>Business Name</dt>
              <dd>{formData.businessName || "—"}</dd>

              <dt>Business Address</dt>
              <dd>{formData.business_address || "—"}</dd>

              <dt>Business Description</dt>
              <dd>{formData.businessDiscription || "—"}</dd>

              <dt>Website</dt>
              <dd>{formData.website || "—"}</dd>

              <dt>Business Logo</dt>
              <dd>{formData.businessLogo || "—"}</dd>
            </dl>
          </div>
        );

      default:
        return null;
    }
  };
  return (
    <div className="queryRegContainer">
      <div className="queryRegCard">
        <header className="queryRegHeader">
          <h2>We’re getting everything ready for you</h2>
          <p className="fs5">
            Tell us a little more about your business so we can set things up
            properly for you.
          </p>
        </header>

        <div className="queryProgressBar">
          {steps.map((step) => {
            const isActive = step.id === currentStep;
            const isComplete = step.id < currentStep;
            return (
              <div
                key={step.id}
                className={`queryStep ${isActive ? "active" : ""} ${isComplete ? "complete" : ""}`}
              >
                <div className="queryStepNumber">{step.id}</div>
                <span>{step.label}</span>
              </div>
            );
          })}
        </div>

        <form className="queryForm" onSubmit={handleSubmit}>
          <div className="queryStepHeader">
            <h3>{steps[currentStep - 1].label}</h3>
            <p>
              Step {currentStep} of {steps.length}
            </p>
          </div>

          {renderStepBody()}

          <div className="queryNavButtons">
            <button
              type="button"
              className="queryButton secondary"
              onClick={handlePrev}
              disabled={currentStep === 1}
            >
              Previous
            </button>

            {currentStep === steps.length ? (
              <button type="submit" className="queryButton primary">
                Submit registration
              </button>
            ) : (
              <button type="submit" className="queryButton primary">
                Next
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
